export const drawerWidth = 270;
export const headerHeight = 10;
export const footerHeight = 10;
